
<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});


function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);


  let yValue = listData.yValue;
  let names = listData.name;
  let xValue = listData.xValue;
  let colorList= listData.colorList
  let maxNumber = Math.max(...yValue);
  let array = new Array(3).fill((maxNumber+500));
  const option= {
    title: {
      textStyle: {
        fontSize: 26,
        fontWeight: "normal",
        color: "#24c1ff", //标题颜色
      },
      top: "0%",
      left: "0%",
    },
    tooltip: {
      trigger: "axis",
      show:false,
    },
    grid: {
      left: "5%",
      right: "5px",
      bottom: "0%",
      top:"18%",
      containLabel: true,
    },
    legend: {
      show: false,
      icon: "roundRect",
      orient: "horizontal",
      itemWidth: 20,
      itemHeight: 15,
      textStyle: {
        fontSize: 26, //字体大小
        color: "#b9c8d4", //字体颜色
      },
      right: "3%", //距离右侧
      data: [],
    },
    calculable: true,
    animation: true,

    xAxis: [
      {
        type: "category",
        triggerEvent: true,  //记住要加上 设置为true后，可触发事件

        axisLabel: {
          interval: 0, // 解决x轴名称过长问题
          textStyle: {
            color: "#fff",
            fontSize: 26,
          },
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: true,
          lineStyle: {
            //y轴网格线设置
            color: "#3F4F5E",
            width: 3,
          },
        },
        data: xValue,
      },
    ],
    yAxis: [
      {
        type: "value",
        name:listData.unit,
        nameGap: 8,
        nameTextStyle: {
          color: "#fff",
          padding:[0,0,30,0],
          fontSize:24,
        },
        splitNumber: 4,
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
          symbol: ["none", "arrow"],
          symbolSize: [5, 10],
          lineStyle: {
            color: "#b2e7ff",
            opacity: 0.3,
          },
        },
        splitLine: {
          //保留网格线
          show: true,
          lineStyle: {
            //y轴网格线设置
            color: "#263648",
            width: 1,
            type:"dashed",
          },
        },
        axisLabel: {
          show: false,
          textStyle: {
            color: "#d1d1d1", //字体颜色
            fontSize: 26,
          },
        },
      },
    ],
    series: [
      {
        name: "电商销售额",
        type: "pictorialBar",
        symbol: "rect",
        symbolSize: [16, 2],
        symbolPosition: "end",
        // symbolOffset: offset[index],
        symbolOffset:[-8, -10],
        z: 2,
        label: {
           show: true,
           position: "top",
           textStyle: {
              color: "#969a9d",
             fontSize:24,
             padding:[10,10,10,-10]
           },
          // formatter: function(value) {
          //   // 当值为 0 时不显示标签
          //   return value.value + listData.unit;
          // }
        },
        tooltip: {
          show: false,
        },
        itemStyle: {
          normal: {
            color: colorList[2] ,
          },
        },
        data: yValue,
      },
      {
        name: "",
        type: "bar",
        barWidth: 16,
        z: 1,
        // showBackground: true,
        // backgroundColor:"rgba(255,255,255,.5)",
        // padding:[0,10,0,10],
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 1,
                color: colorList[0] ,
              },
              {
                offset: 0.2,
                color: colorList[1] ,
              },
              {
                offset: 0,
                color:  colorList[1],
              },
            ]),
            // borderColor: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //    {
            //       offset: 0,
            //       color: colorList[index].borderColor  ,
            //    },
            //    {
            //       offset: 0.5,
            //       color: colorList[index].borderColor  ,
            //    },
            //    {
            //       offset: 1,
            //       color: "transparent",
            //    },
            // ]),
          },
        },
        data: yValue,
      },
      {
        name: '背景',
        type: 'bar',
        barWidth: 48,
        data: array,
        barGap: '-200%',
        z:0,
        itemStyle: {
          normal: {
            color: 'rgba(255, 255, 255, 0.05)',
            barBorderRadius: 0,

          }
        },
      },
    ],
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);


}
window.addEventListener("resize", () => {
  chartInstance.resize();
});

</script>
<style lang="less"></style>
